/* esm.sh - unified@11.0.5 */
export * from "/*unified@11.0.5/esnext/unified.mjs";
